import {Component} from '@angular/core';

@Component({
  selector: 'app-auctions-about',
  imports: [],
  templateUrl: './auctions-about.component.html',
  styleUrl: './auctions-about.component.scss'
})
export class AuctionsAboutComponent {

}
